import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

export const authGuard: CanActivateFn = (route, state) => {

  const oAuthService = inject(OAuthService);
  const router = inject(Router);

  if (oAuthService.hasValidAccessToken()) {
    return true;
  } else {
    oAuthService.initLoginFlow()
    return false;
  }
};
